import { render } from "./Porcentajes.vue?vue&type=template&id=ae7f5286"
import script from "./Porcentajes.vue?vue&type=script&lang=js"
export * from "./Porcentajes.vue?vue&type=script&lang=js"

import "./Porcentajes.vue?vue&type=style&index=0&id=ae7f5286&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__